import AscOrders from 'pages/MyOrdersPage/AscOrders/AscOrders';

export default AscOrders;
